import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_END_POINT, TOKEN } from "../../../constant";
import { method } from "lodash";
import { toast } from "react-toastify";
import CommonTable from "../../Table/CommonTable";
import axios from "axios";
// import Loader from '../../components/Loader/Loader';

function Call() {
  const navigate = useNavigate();
  const { id } = useParams();
  const astrologerId = id;
  const [callList, setCallList] = useState();
  const [loading, setLoading] = useState(false);
  const [isOnline, setIsOnline] = useState({});
  const [callDetails, setCallDetails] = useState();

  const handleCallStatusChange = async (row) => {
    // setLoading(true)
    const handleStatusChangeUrl = `${API_END_POINT}astro-user-call/toggle-call?callId=${row.callId}`;
    const handleStatusChangeHeaders = {
      Authorization: `Bearer ${TOKEN}`
    };
    try {
      const response = await fetch(handleStatusChangeUrl, {
        method: "PUT",
        headers: handleStatusChangeHeaders
      });

      if (!response.ok) {
        toast.error("failed to update call status");
      }
      toast.success("call status updated successfully");
      getAstrologerCallList(astrologerId);
    } catch (error) {
      console.log(
        "error in handleCallStatusChange () --->>> Call.jsx --->>>",
        error
      );
    } finally {
      // setLoading(false)
    }
  };

  const handleStatusChange = async (id) => {
    const updateStatusUrl = `${API_END_POINT}astro-user-call/approve-call?callId=${id}`;
    const updateStatusHeader = {
      Authorization: `Bearer ${TOKEN}`
    };
    try {
      const response = await fetch(updateStatusUrl, {
        method: "POST",
        headers: updateStatusHeader
      });

      if (!response.ok) {
        toast.error("failed to update status");
        return;
      }
      toast.success("status changed successfully");
    } catch (error) {
      console.log("handle status change --->>>", error);
    } finally {
      getAstrologerCallList(astrologerId);
    }
  };
  const handleJoinChannel = async (id) => {
    try {
      const response = await axios.post(
        `${API_END_POINT}astro-user-call/astrologer-join-call?astrologerId=${astrologerId}&callId=${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${TOKEN}`
          }
        }
      );

      const { channelName, agoraToken, appId } = response.data.data;
      setCallDetails(response.data.data);

      navigate("/agoraCall", {
        state: {
          channelName,
          agoraToken,
          appId,
          astrologerId
        }
      });
    } catch (error) {
      console.error("Error joining channel:", error);
    }
  };

  // useEffect(() => {
  //   getAstrologerCallList(astrologerId);
  // }, [astrologerId]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      getAstrologerCallList(astrologerId);
    }, 3000);

    return () => clearInterval(intervalId);
  }, [astrologerId]);

  const getAstrologerCallList = async (astrologerId) => {
    // setLoading(true);
    const getAstrologerCallListUrl = `${API_END_POINT}astro-user-call/get/${astrologerId}`;
    const getAstrologerCallListHeaders = {
      Authorization: `Bearer ${TOKEN}`
    };
    try {
      const response = await fetch(getAstrologerCallListUrl, {
        method: "GET",
        headers: getAstrologerCallListHeaders
      });
      if (!response.ok) {
        toast.error("error while fetching astrologer call list");
        return;
      }
      const responseData = await response.json();
      setCallList(responseData.data);
    } catch (error) {
      console.log("error in getAstrologerCallList() --->>> ", error);
    } finally {
      setLoading(false);
    }
  };

  const callListColumn = [
    {
      name: "User Name",
      cell: (row) => row?.userName
    },
    {
      name: "Gender",
      cell: (row) => row?.gender
    },
    {
      name: "DOB",
      cell: (row) => row?.userDOB
    },
    // {
    //   name: 'Mobile No',
    //   cell: (row) => row?.userMobileNo,
    // },
    {
      name: "Approve Status",
      cell: (row, index) => {
        isOnline[row?.callId] = row?.isCallApproved;
        return (
          <div className="button r" id="button-1">
            <input
              type="checkbox"
              className="checkbox"
              checked={isOnline[row?.callId]}
              onChange={(e) =>
                row.isCallApproved == false && handleStatusChange(row?.callId)
              }
            />
            <div className="knobs"></div>
            <div className="layer"></div>
          </div>
        );
      }
    },
    {
      name: "Join Call",
      cell: (row) => (
        <div className="btn">
          <button
            onClick={() => {
              if (row.isCallCompleted === true) {
                toast.warning("Call is already completed");
              } else if (row.isCallApproved === false) {
                toast.warning("Approve a request first");
              } else {
                handleJoinChannel(row.callId);
              }
            }}
          >
            Join Call
          </button>
        </div>
      )
    },
    {
      name: "Marital Status",
      cell: (row) => row?.maritalStatus
    },
    {
      name: "Call Time",
      cell: (row) => row?.callTime
    },
    // {
    //   name: "Call Status",
    //   cell: (row, index) => {
    //     return (
    //       <div className="button r" id="button-1">
    //         <input
    //           type="checkbox"
    //           className="checkbox"
    //           checked={row.isCallCompleted}
    //           onChange={(e) => handleCallStatusChange(row)}
    //           // onChange={handleCallStatusChange}
    //         />

    //         <div className="knobs"></div>
    //         <div className="layer"></div>
    //       </div>
    //     );
    //   }
    // },
    {
      name: "Call Status",
      cell: (row) => (
        <div>
          {row.isCallCompleted ? (
            <span style={{ color: "green" }}>Completed</span>
          ) : (
            <span style={{ color: "red" }}>Pending</span>
          )}
        </div>
      )
    }
  ];

  return (
    <main className="main">
      <h3>Astrologer Call</h3>
      {loading ? (
        <>{/* <Loader/> */}</>
      ) : (
        <>
          <div
            style={{ marginTop: "10px" }}
            onClick={(e) => {
              console.log("object", e.target);
            }}
          >
            <CommonTable columns={callListColumn} data={callList} />
          </div>
        </>
      )}
    </main>
  );
}

export default Call;
